/* ===========================================================
   LINEUP THEME — main JS
   =========================================================== */

(function () {
  'use strict';

  // ---------- Hero slideshow ----------
  function initHero() {
    const hero = document.querySelector('[data-hero-slideshow]');
    if (!hero) return;

    const slides = hero.querySelectorAll('.hero-slide');
    const dots = hero.querySelectorAll('.hero-dots button');
    if (slides.length < 2) return;

    let idx = 0;
    let timer;

    function show(n) {
      slides.forEach((s, i) => s.classList.toggle('active', i === n));
      dots.forEach((d, i) => d.classList.toggle('active', i === n));
      idx = n;
    }

    function next() { show((idx + 1) % slides.length); }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        show(i);
        clearInterval(timer);
        timer = setInterval(next, 6000);
      });
    });

    timer = setInterval(next, 6000);
  }

  // ---------- Mobile drawer ----------
  function initDrawer() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const overlay = document.querySelector('[data-drawer-overlay]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('open');
      overlay && overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('open');
      overlay && overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    overlay && overlay.addEventListener('click', close);
    drawer.querySelectorAll('[data-drawer-close]').forEach(el => {
      el.addEventListener('click', close);
    });
  }

  // ---------- PDP gallery ----------
  function initGallery() {
    const gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;
    const main = gallery.querySelector('[data-pdp-main]');
    const thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        thumbs.forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const url = t.getAttribute('data-img');
        if (main && url) main.src = url;
      });
    });
  }

  // ---------- PDP qty stepper ----------
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      const dec = wrap.querySelector('[data-qty-dec]');
      const inc = wrap.querySelector('[data-qty-inc]');
      if (!input) return;
      dec && dec.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.value = v;
      });
      inc && inc.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value || '1', 10) + 1);
        input.value = v;
      });
    });
  }

  // ---------- Cart count refresh on AJAX add ----------
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const el = document.querySelector('[data-cart-count]');
        if (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        }
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHero();
    initDrawer();
    initGallery();
    initQty();
    refreshCartCount();
  });

  // expose for other code
  window.Lineup = { refreshCartCount };
})();
